var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{attrs:{"fixed":""}},[_c('v-toolbar-side-icon',{on:{"click":_vm.toggleSidebar}}),_vm._t("title",[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))])],{"title":_vm.title}),_c('v-spacer'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }